import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelecaoVisualizacao = _resolveComponent("SelecaoVisualizacao")!
  const _component_SelecaoEdicao = _resolveComponent("SelecaoEdicao")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.selecao.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_SelecaoVisualizacao, {
          key: 0,
          selecao: _ctx.selecao,
          ehPrimeiro: _ctx.ehPrimeiro,
          ehUltimo: _ctx.ehUltimo,
          onEditar: _ctx.editar,
          onExcluir: _ctx.excluir,
          onDescer: _ctx.descer,
          onSubir: _ctx.subir
        }, null, 8, ["selecao", "ehPrimeiro", "ehUltimo", "onEditar", "onExcluir", "onDescer", "onSubir"]))
      : _createCommentVNode("", true),
    (_ctx.selecao.getEmEdicao())
      ? (_openBlock(), _createBlock(_component_SelecaoEdicao, {
          key: 1,
          selecao: _ctx.selecao
        }, null, 8, ["selecao"]))
      : _createCommentVNode("", true)
  ]))
}